

import React, { useEffect } from 'react';
import { useState, useRef } from 'react';

import {
    Box,
    Stack,
    Typography,
    InputLabel, FormControl, Select, Button,
    TextField
} from '@mui/material';

import OrganizationDropdown from '../../../organization/OrganizationDropdown';
import { AdminApi } from '../../../../api/AdminApi';
// Reference Code
//  HealthDataImportCard

export default function MemberImportForm({ defaultOrg, canSelectOrg = true }) {
    const inputRef = useRef(null);
    const [statusMessage, setStatusMessage] = React.useState("");
    const [isError, setIsError] = React.useState(false);
    const [file, setFile] = useState(null);
    const [org, setOrg] = useState(null);
    const [password, setPassword] = useState("");

    useEffect(() => {
        // showMessage("Hello World", false);
        if (canSelectOrg == false) {
            setOrg(defaultOrg);
        }
    }, []);


    useEffect(() => {
        setOrg(defaultOrg);
    }, [defaultOrg]);

    // function selectDefaultOrg(orgId) {

    // }

    // --- Message 
    function showMessage(message, isSuccess) {
        setStatusMessage(message);
        setIsError(!isSuccess);
    }


    const onOrganizationSelected = (org) => {
        console.debug("onOrganizationSelected=", org);
        // setOrg(org)
        setOrg(org);
    }

    // --- File Handling --- 

    const handleFileChange = (e) => {
        const target = e.target;
        const files = target.files;
        console.debug("files=", files);
        if (files && files.length > 0) {
            setFile(files[0]);
        }
    }

    const fileBox = file ? (
        <Box>{file.name}</Box>
    ) : (
        <Box>no file selected</Box>
    );

    // --- Import ---
    const showImportError = (importErrors) => {
        // convert the errors to string

        let errorString = "";
        for (let errorItem of importErrors) {
            let { line, error } = errorItem;

            errorString += `Line ${line}: ${error}\n`;
        }

        if (errorString === "") {
            errorString = "Unknown error";
        }

        showMessage(errorString, false);
    }

    const showImportResult = (importResult) => {
        let successCount = importResult.length;

        showMessage(`Imported ${successCount} records`, true);
    }

    const resetForm = () => {
        setFile(null);
        setOrg(null);
        setPassword("");
        // showMessage("", false);
    }


    const handleImport = async () => {
        console.debug("handleImport");
        if (file === null) {
            showMessage("No file selected", false);
            return;
        }

        if (password === "") {
            showMessage("Password is empty", false);
            return;
        }

        if (org === null) {
            showMessage("Please select an organization", false);
            return;
        }


        // showMessage("Importing...", true);
        showMessage("", false);
        // showing the information 
        console.debug("org=", org);
        console.debug("password=", password);
        console.debug("file=", file);

        // AdminApi.batchCreateMember(orgID, password, fileObject,
        //             (isSuccess, msg, data) => {
        //                 console.debug("result: isSuccess=", isSuccess, " msg=", msg, " data=", data);
        //             });

        try {
            let orgID = org.id;
            let fileObject = file;
            let result = await AdminApi.batchCreateMember(orgID, password, fileObject);

            let importStatus = result.import_status;
            let importErrors = result.import_error;
            let importResult = result.import_result;

            console.debug("importStatus=", importStatus);
            console.debug("importErrors=", importErrors);
            console.debug("importResult=", importResult);
            // console.debug("importResult=", importResult);

            if (importStatus === false) {
                showImportError(importErrors);
            } else {
                showImportResult(importResult);
                resetForm();
            }

        } catch (error) {
            console.error("Error: ", error);
            showMessage("Error: " + error, false);
        }


    }

    // --- Render ---

    return (
        <Stack direction="column" gap={1} sx={{ p: 2 }}>

            {
                canSelectOrg &&
                <Box>

                    <OrganizationDropdown
                        onOrganizationSelected={onOrganizationSelected}
                        selectButton={false}
                    />

                </Box>
            }
            {/* {
                !canSelectOrg &&
                <Box>
                    <Typography variant="body1">機構：{org ? org.name_zh : ""}</Typography>
                    <Typography variant="body1">機構ID：{org ? org.id : ""}</Typography>
                </Box>

            } */}
            <Stack direction="row" gap={3} alignItems="center" sx={{ mt: 2 }}>
                <Typography variant="body1">密碼：</Typography>
                <FormControl variant="outlined">
                    <TextField
                        id="password"
                        type="password"
                        label="Password"
                        value={password}
                        onChange={(e) => {
                            console.debug("password=", e.target.value);
                            setPassword(e.target.value);
                        }}
                    />
                </FormControl>
            </Stack>

            <Stack direction="row" gap={3} alignItems="center">
                <Typography variant="body1">學生CSV檔案：</Typography>

                {fileBox}
                <Button
                    variant="outlined"
                    component="label"
                >
                    Upload File
                    <input
                        type="file"
                        hidden
                        ref={inputRef}

                        onChange={handleFileChange}
                    />
                </Button>


            </Stack>
            <Box>
                <Button
                    variant="contained"
                    component="label"
                    onClick={handleImport}
                >
                    導入學生資料
                </Button>
            </Box>
            {
                statusMessage &&
                <Box sx={{ whiteSpace: 'pre-line', p: 2, backgroundColor: isError ? "#faa" : "#aea" }}>
                    {statusMessage}
                </Box>
            }

        </Stack>
    );
}
